import { ORDER_TYPE_NEW, ORDER_PRODUCT_TYPE_SET } from "@/constants/order";

const COUNTRY_IDS = [13];
const TOTALS = { 3: 90, 4: 120, 5: 180, 6: 212, 7: 236, 8: 270, 9: 295 };

// The base unit price stays 49; the grid only changes the line costs.
export function getFrance49Basket(order, basket) {
  if (!order || Number(order.type_id) !== ORDER_TYPE_NEW ||
      !COUNTRY_IDS.includes(Number(order.country_id)) || order.set_id ||
      !basket || !Array.isArray(basket.products)) return null;

  const rows = [];
  for (let index = 0; index < basket.products.length; index++) {
    const product = basket.products[index];
    const free = basket.free && basket.free[index];
    if (free === true || free === 1 || free === "1") continue;
    const quantity = Number(basket.quantity && basket.quantity[index]);
    if (!product || !product.id || product.type === ORDER_PRODUCT_TYPE_SET ||
        Number(basket.costs && basket.costs[index]) !== 49 ||
        !Number.isInteger(quantity) || quantity < 1) return null;
    rows.push({ index, quantity });
  }
  if (!rows.length) return null;
  const quantity = rows.reduce((sum, row) => sum + row.quantity, 0);
  return { rows, quantity, total: TOTALS[quantity] };
}

export function getFrance49LineTotal(order, basket, rowIndex) {
  const grid = getFrance49Basket(order, basket);
  if (!grid || grid.total === undefined) return null;
  let precedingQuantity = 0;
  for (const row of grid.rows) {
    if (row.index === rowIndex) {
      // Round cumulative boundaries so split rows still sum to the exact target.
      const units = grid.total * 10000;
      return (Math.round(units * (precedingQuantity + row.quantity) / grid.quantity) -
        Math.round(units * precedingQuantity / grid.quantity)) / 10000;
    }
    precedingQuantity += row.quantity;
  }
  return null;
}
